import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styles from '../badgeBase.module.scss';
import BadgeShieldCheck from '../BadgeShieldCheck';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import nextBadgeTooltipId from '../nextBadgeTooltipId';

const LABEL = 'Twine Recommends';
const DESCRIPTION =
  'This expert is verified and hand picked by Twine';

const TwineRecommends = ({
  user,
  className = '',
  style,
  iconOnly = false,
  // InstantSearch browse cards use renderToStaticMarkup — OverlayTrigger
  // is stripped, so fall back to an inline CSS tooltip there.
  overlay = true,
  ...rest
}) => {
  const tooltipIdRef = useRef(null);

  if (!user || !user.twine_recommends) {
    return null;
  }

  // Ignore legacy title prop still passed by older call sites
  // eslint-disable-next-line no-unused-vars
  const { title, ...spanRest } = rest;

  if (!overlay && tooltipIdRef.current === null) {
    tooltipIdRef.current = nextBadgeTooltipId('twine-recommends-tooltip');
  }
  const tooltipId = tooltipIdRef.current;

  const classNames = [
    styles.badge,
    styles.twineRecommends,
    iconOnly ? styles.iconOnly : null,
    !overlay ? styles.withCssTooltip : null,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const badge = (
    <span
      className={classNames}
      style={style}
      tabIndex={0}
      data-browse-status-badge={overlay ? undefined : ''}
      aria-label={iconOnly ? LABEL : undefined}
      aria-describedby={tooltipId || undefined}
      {...spanRest}
    >
      <BadgeShieldCheck variant="twineRecommends" outline={!iconOnly} />
      {iconOnly ? null : <span className={styles.label}>{LABEL}</span>}
      {!overlay ? (
        <span id={tooltipId} className={styles.cssTooltip} role="tooltip">
          {DESCRIPTION}
        </span>
      ) : null}
    </span>
  );

  if (!overlay) {
    return badge;
  }

  return (
    <OverlayTrigger
      placement="bottom"
      trigger={['hover', 'focus']}
      overlay={
        <Popover id="twine-recommends" placement="bottom">
          {DESCRIPTION}
        </Popover>
      }
    >
      {badge}
    </OverlayTrigger>
  );
};

TwineRecommends.propTypes = {
  user: PropTypes.shape({
    twine_recommends: PropTypes.bool,
  }),
  className: PropTypes.string,
  style: PropTypes.object,
  title: PropTypes.string,
  iconOnly: PropTypes.bool,
  overlay: PropTypes.bool,
};

export default TwineRecommends;
